import { useState } from "react";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";

const TreeItem = ({ item, onToggle, level = 0 }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const hasChildren = item.children && item.children.length > 0;
    const isRoot = level === 0;

    return (
        <div className={`flex flex-col ${level > 0 ? "ml-6 border-l border-gray-100" : ""}`}>
            <div
                className={`flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer select-none ${isRoot ? "bg-gray-50/60" : ""}`}
                onClick={() => onToggle(item.id)}
            >
                {hasChildren ? (
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setIsExpanded(!isExpanded); }}
                        className="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 shrink-0 transition-transform duration-200"
                        style={{ transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)" }}
                    >
                        <img src="/icons/right-arrow.svg" alt="arrow" className="w-3 h-3 opacity-50" />
                    </button>
                ) : (
                    <div className="w-5 shrink-0" />
                )}

                <div
                    onClick={(e) => { e.stopPropagation(); onToggle(item.id); }}
                    className={`w-4 h-4 shrink-0 rounded border flex items-center justify-center transition-colors ${item.checked
                        ? "bg-blue-600 border-blue-600"
                        : "bg-white border-gray-300 hover:border-blue-400"
                        }`}
                    role="checkbox"
                    aria-checked={item.checked}
                    tabIndex={0}
                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onToggle(item.id)}
                >
                    {item.checked && <CheckIcon className="w-2.5 h-2.5 text-white" />}
                </div>

                <span className={`text-sm leading-snug ${isRoot ? "font-semibold text-gray-800" : "text-gray-600"}`}>
                    {item.name}
                </span>
            </div>

            {hasChildren && isExpanded && (
                <div className="flex flex-col gap-0.5 pb-2">
                    {item.children.map((child) => (
                        <TreeItem key={child.id} item={child} onToggle={onToggle} level={level + 1} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default TreeItem;
